import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Gracias from "@/pages/Gracias";
import Dudas from "@/pages/Dudas";
import ParejasLanding from "@/pages/ParejasLanding";
import DeportistasLanding from "@/pages/DeportistasLanding";
import OficinistasLanding from "@/pages/OficinistasLanding";
import EsfuerzoLanding from "@/pages/EsfuerzoLanding";
import { AvisoLegal, Privacidad, Cookies } from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSettings from "@/pages/AdminSettings";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#5C5366]">
        Cargando…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/parejas" element={<ParejasLanding />} />
            <Route path="/deportistas" element={<DeportistasLanding />} />
            <Route path="/oficinistas" element={<OficinistasLanding />} />
            <Route path="/esfuerzo" element={<EsfuerzoLanding />} />
            <Route path="/dudas" element={<Dudas />} />
            <Route path="/gracias" element={<Gracias />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute>
                  <AdminSettings />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
